import StepWizard, {StepWizardProps, StepWizardChildProps} from 'react-step-wizard';

import {WizardNav} from './WizardNav';

type Props = {
    instance?: (wizard: StepWizardProps) => void;
    navItems?: string[];
    className?: string;
    children: React.ReactElement<StepWizardChildProps>[]
}

export const Wizard: React.FC<Props> = ({instance, navItems, className, children}) => (
    <div className={className}>
        <StepWizard
            isLazyMount
            transitions={{
                enterRight: 'nothing',
                enterLeft: 'nothing',
                exitRight: 'nothing',
                exitLeft: 'nothing',
                intro: 'nothing'
            }}
            instance={instance}
            nav={(<WizardNav navItems={navItems} />)}
        >
            {children}
        </StepWizard>
    </div>
);